import { Suspense, useCallback } from 'react';
import { Route } from 'react-router';
import * as ROUTES from '../../../routes';
import AngularRouteFetcher from '../../../routing/AngularRouteFetcher';
import LoadingIndicatorFull from '../../components/LoadingIndicatorFull';
import NavigationTabs, { Tab } from '../../components/NavigationTabs';
import PageHeader from '../../components/PageHeader';
import PageStatic from '../../components/PageStatic';
import SwitchDefaultRoute from '../../components/SwitchDefaultRoute';
import { useAppContext } from '../../hooks/useAppContext';
import useClippyStateUpdate, { ClippyState } from '../../hooks/useClippyStateUpdate';
import { isFeatureEnabled } from '../../services/Features';
import replacement from '../../services/Replacement';
import { replaceUrl } from '../../services/Router';
import { isAnyAdmin } from '../../services/User';
import ActivityStreamTab from '../ActivityStream/tab';
import PeopleTab from '../PeopleTab/lazy';

export default function PeoplePage() {
    const { user } = useAppContext();
    const tabs: Tab[] = [
        {
            label: 'Team',
            link: ROUTES.PEOPLE_TEAM,
            visible: true,
        },
        {
            label: 'Directory',
            link: ROUTES.PEOPLE_DIRECTORY,
            visible: !isAnyAdmin(user),
        },
        {
            label: 'Activities',
            link: ROUTES.PEOPLE_ACTIVITES,
            visible: true,
        },
        {
            label: replacement('messages.menu.title'),
            link: ROUTES.PEOPLE_MESSAGES,
            visible: isFeatureEnabled('message'),
        },
    ];

    const handleClippyStateUpdate = useCallback((nextState: ClippyState) => {
        // Go back to param-less route when closing Clippy via its own trigger button.
        if (nextState.isOpen && nextState.isClosing) {
            replaceUrl(ROUTES.BASE + ROUTES.PEOPLE_TEAM);
        }
    }, []);

    useClippyStateUpdate(handleClippyStateUpdate);

    return (
        <>
            <PageStatic>
                <PageHeader title="People" />
            </PageStatic>
            <NavigationTabs tabs={tabs} />
            <Suspense fallback={<LoadingIndicatorFull />}>
                <SwitchDefaultRoute defaultPath={ROUTES.PEOPLE}>
                    <Route path={ROUTES.PEOPLE_TEAM} exact component={PeopleTab} />
                    <Route path={ROUTES.PEOPLE_TEAM_USER} exact component={PeopleTab} />
                    <Route
                        path={ROUTES.PEOPLE_DIRECTORY}
                        exact
                        render={({ match }) => (
                            <AngularRouteFetcher
                                match={match}
                                stateGetter={() =>
                                    import(
                                        /* webpackChunkName: 'UserDirectory' */ '../../../screens/users/pages/user-directory/route'
                                    )
                                }
                            />
                        )}
                    />
                    <Route exact path={ROUTES.PEOPLE_ACTIVITES} component={ActivityStreamTab} />
                    <Route
                        path={ROUTES.PEOPLE_MESSAGES}
                        exact
                        render={({ match }) => (
                            <AngularRouteFetcher
                                match={match}
                                stateGetter={() =>
                                    import(
                                        /* webpackChunkName: 'Messages' */ '../../../screens/message/pages/message-company-tab-controller/route'
                                    )
                                }
                            />
                        )}
                    />
                </SwitchDefaultRoute>
            </Suspense>
        </>
    );
}
